<template>
  <v-layout>
    <v-flex>
      <v-card flat>
        <v-tabs v-model="tabs.active" color="#9ec8c8" slider-color="secondary">
          <v-tab ripple>Members</v-tab>
          <v-tab ripple>Collaborators</v-tab>

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <ListGroup_Member_BTRT
                  :showItems.sync = "comp_membersList"
                  :showItemsProp = "membersProp"
                  @newList = "comp_membersList=$event"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

					<v-tab-item>
						<v-card flat>
							<v-card-text>
                <ListGroup_Collaborator
                  :showItems.sync = "comp_collaboratorsList"
                  :showItemsProp = "collaboratorsProp"
                  @newList = "comp_collaboratorsList=$event"
                />
							</v-card-text>
						</v-card>
					</v-tab-item>
        </v-tabs>
      </v-card>
    
    </v-flex>
  </v-layout>
	
</template>

<script>
import ListGroup_Collaborator from "../../components/ListGroup_Collaborator";
import ListGroup_Member_BTRT from "../../components/ListGroup_Member_BTRT";
import common from "../../functions/general";

export default {
  name: "events_page_btrt",
  props: {
    showItemsM: {
      type: Array,
      required: true
    },
    showItemsC: {
      type: Array,
      required: true
    }
  },
  components: {
    ListGroup_Collaborator: ListGroup_Collaborator,
    ListGroup_Member_BTRT: ListGroup_Member_BTRT
  },
  data () {
    return {
      // optionList: [],
      membersList_C: [], // check if just need local var at computed
      collaboratorsList: [],
      membersProp: [],
      collaboratorsProp: [],
      tabs: {
        active: 0,
      },
      memberGlobal_id: ""
    }
  },
  watch: {},
  methods: {
    update_collaborators (newArr) {
      // not in used anywhere, could be removed.
    },
    get_arrIndex(arr, targetID, property) {
      // if (arr != undefined) {
      //   return arr.findIndex(obj => obj["id"] === targetID);
      // }
      return arr.findIndex(obj => obj[property] === targetID);
    }
  },
  async mounted () {
    this.memberGlobal_id = common.Setting.getEventsMemberGlobalID();
		// get member_prop from DB.
    let tempk = await common.App.arango_app_selections("events", "btrt_prop");
		let tempObj = [{
			name: tempk[0].label,
			g_role_id: tempk[0]._id,
			value: false
		}];

    this.membersProp = structuredClone(tempObj);

    // get collaborators_Prop from DB.
		let tempk1 = await common.App.arango_app_selections("events", "collaborators");
    let Len = tempk1.length;
    for (let j = 0; j < Len; j++) {
      let tempObj1 = {
      	name: tempk1[j].label,
      	g_role_id: tempk1[j]._id,
      	value: false
      };
      this.collaboratorsProp.push(tempObj1);
    }
  },
  computed: {
    comp_membersList: {
      get: function () {
        this.membersList_C = [];
        // restructure membersList format.
        
        var len = this.showItemsM.length;
        if (len == 0) {
          this.membersList_C.push([]);
        } else {
          for (let i = 0; i < len; i++) {
            let group = [];
            let temp = {};
            if (Object.keys(this.showItemsM[i]).length > 0) {

              temp["username"] = this.showItemsM[i]["username"];
              temp["name"] = this.showItemsM[i]["name"];
              temp["prop"] = [{
                name: this.membersProp[0]["name"],
                g_role_id: this.membersProp[0]["g_role_id"],
                value: true
              }];
              temp["id"] = this.showItemsM[i]["mapID"];
              temp["comp"] = this.showItemsM[i]["Lcomp"];
              temp["dept"] = this.showItemsM[i]["Ldept"];
              temp["email"] = this.showItemsM[i]["email"];
              temp["_key"] = this.showItemsM[i]["_key"];
              group.push(temp);
              let len1 = this.showItemsM[i].observers.length;
              for (let j = 0; j < len1; j++) {
                let temp1 = {};
                temp1["username"] = this.showItemsM[i].observers[j]["username"];
                temp1["name"] = this.showItemsM[i].observers[j]["name"];
                temp1["prop"] = structuredClone(this.membersProp);
                temp1["id"] = this.showItemsM[i].observers[j]["mapID"];
                temp1["comp"] = this.showItemsM[i].observers[j]["Lcomp"];
                temp1["dept"] = this.showItemsM[i].observers[j]["Ldept"];
                temp1["email"] = this.showItemsM[i].observers[j]["email"];
                temp1["_key"] = this.showItemsM[i].observers[j]["_key"];
                group.push(temp1);
              }

            }
            this.membersList_C.push(group);
          }
        }

        return this.membersList_C;
      },
      set:function(val){
        // restructure to return parent (crud page)
        let tempArr = [];
        let len3 = val.length;
        for (let m = 0; m < len3; m++) {
          let selfAsmt = val[m].find(e => e.prop[0].value == true);

          if (selfAsmt == undefined ) {
            common.wMsgBox.Info("Please assign at least 1 member to each Group.");
            tempArr.push({});
          } else {
            let tt = {};
            tt["Lcomp"] = selfAsmt["comp"];
            tt["Ldept"] = selfAsmt["dept"];
            tt["email"] = selfAsmt["email"];
            tt["mapID"] = selfAsmt["id"];
            tt["name"] = selfAsmt["name"];
            tt["username"] = selfAsmt["username"];
            tt["_key"] = selfAsmt["_key"];
            tt["created"] = "";
            tt["created_by"] = "";
            tt["modified"] = "";
            tt["modified_by"] = "";

            tempArr.push(tt);

            let tempObsvr = val[m].filter(e => e.prop[0].value == false);
            let kk = [];
            let len4 = tempObsvr.length;
            for (let n = 0; n < len4; n++) {
              let ttt = {};
              ttt["Lcomp"] = tempObsvr[n]["comp"];
              ttt["Ldept"] = tempObsvr[n]["dept"];
              ttt["email"] = tempObsvr[n]["email"];
              ttt["mapID"] = tempObsvr[n]["id"];
              ttt["name"] = tempObsvr[n]["name"];
              ttt["username"] = tempObsvr[n]["username"];
              ttt["_key"] = tempObsvr[n]["_key"];
              ttt["created"] = "";
              ttt["created_by"] = "";
              ttt["modified"] = "";
              ttt["modified_by"] = "";

              kk.push(ttt);
            }
            tempArr[m]["observers"] = kk;
          }
        }
        this.$emit("newMember",tempArr); // NOTE: to send back to events_crud.vue

        // NOTE: distinct members, then update collaborator.
        let tempArr1 = [];
        let len5 = val.length;
        for (let p = 0; p < len5; p++) {
          let len6 = val[p].length;
          for (let q = 0; q < len6; q++) {
            tempArr1.push({
              id: val[p][q].id,
              name: val[p][q].name,
              username: val[p][q].username,
              comp: val[p][q].comp,
              dept: val[p][q].dept,
              email: val[p][q].email,
              _key: val[p][q]._key
            });
          }
        }

        let LEN = tempArr1.length;
        var distMember = {};
        for (let g = 0; g < LEN; g++) {
          var el = tempArr1[g];
          distMember[el.id] = el;
        }
        distMember = Object.values(distMember);

        let collaboratorM = [];
        let collaboratorO = [];
        let LEN1 = this.comp_collaboratorsList.length;
        for (let h = 0; h < LEN1; h++) {
          let qq = this.comp_collaboratorsList[h].prop.filter(e => e.g_role_id==this.memberGlobal_id)[0].value;
          if (qq) {
            // NOTE: member-true
            collaboratorM.push(this.comp_collaboratorsList[h]);
          } else {
            collaboratorO.push(this.comp_collaboratorsList[h]);
          }
        }

        // OWK: continue from here on....
        let LEN_distMember = distMember.length;
        let LEN_collaboratorM = collaboratorM.length;
        
        if (LEN_distMember > LEN_collaboratorM) {
          // NOTE: add to collaborator
          for (let a = 0; a < LEN_distMember; a++) {
            // NOTE: identify new member obj.
            let found_1 = collaboratorM.find(e => e.id == distMember[a].id);
            
            if (found_1 == undefined) {
              // NOTE: check if new member obj exist with other roles.
              let found_1o = collaboratorO.find(e => e.id == distMember[a].id);

              if (found_1o == undefined) {
                // NOTE: add to collaborator
                let tempRole = structuredClone(this.collaboratorsProp);
                let tempLEN = tempRole.length;
                for (let b = 0; b < tempLEN; b++) {
                  if (tempRole[b].g_role_id == this.memberGlobal_id) {
                    tempRole[b].value = true;
                  }
                }

                let bbb = {
                  mapID: distMember[a].id,
                  name: distMember[a].name,
                  username: distMember[a].username,
                  Lcomp: distMember[a].comp,
                  Ldept: distMember[a].dept,
                  role: tempRole
                };
                this.showItemsC.push(structuredClone(bbb));

              } else {
                // NOTE: update member-true                
                let IDX = this.get_arrIndex(this.showItemsC, found_1o.id, "mapID");
                let tempLEN1 = this.showItemsC[IDX].role.length;
                for (let c = 0; c < tempLEN1; c++) {
                  if (this.showItemsC[IDX].role[c].g_role_id == this.memberGlobal_id) {
                    this.showItemsC[IDX].role[c].value = true;
                  }
                }
              }
            }
          }
        } else if (LEN_distMember < LEN_collaboratorM) {
          // NOTE: remove from collaborator
          for (let d = 0; d < LEN_collaboratorM; d++) {
            // NOTE: identify obj to remove
            let found_2 = distMember.find(e => e.id == collaboratorM[d].id);

            if (found_2 == undefined) {
              let IDX2 = this.get_arrIndex(this.showItemsC, collaboratorM[d].id, "mapID");
              let tempLEN2 = this.showItemsC[IDX2].role.length;
              let check = 0;
              for (let e = 0; e < tempLEN2; e++) {
                
                if (this.showItemsC[IDX2].role[e].value == true) {
                  check = check + 1;
                }
              }

              if (check > 1) {
                // NOTE: update member-false
                for (let f = 0; f < tempLEN2; f++) {
                  if (this.showItemsC[IDX2].role[f].g_role_id == this.memberGlobal_id) {
                    this.showItemsC[IDX2].role[f].value = false;
                  }
                }
              } else {
                // NOTE: remove obj from showItemsC
                this.showItemsC.splice(IDX2,1);
              }
            }
          }
        } else {
          return;
        }
      }
    },
    comp_collaboratorsList: {
      get: function () {
        this.collaboratorsList = [];
        
        var len2 = this.showItemsC.length;
        if (len2 == 0) {
          // this.collaboratorsList.push([]);
        } else {
          for (let i = 0; i < len2; i++) {
            let temp = {};
            temp["username"] = this.showItemsC[i]["username"];
            temp["name"] = this.showItemsC[i]["name"];
            temp["prop"] = this.showItemsC[i]["role"];
            temp["id"] = this.showItemsC[i]["mapID"];
            temp["comp"] = this.showItemsC[i]["Lcomp"];
            temp["dept"] = this.showItemsC[i]["Ldept"];
            this.collaboratorsList.push(temp);
          }
        }
        return this.collaboratorsList;
        // return this.showItemsC;
      },
      set:function(val){
        let LenC = val.length;
        if (LenC == 0) {
          // OWK: check the structure
        } else {
          let tempC = [];
          for (let A = 0; A < LenC; A++) {
            tempC.push({
              Lcomp: val[A].comp,
              Ldept: val[A].dept,
              mapID: val[A].id,
              name: val[A].name,
              username: val[A].username,
              role: structuredClone(val[A].prop)
            });
          }
          this.$emit("newColl", tempC);
        }

      }
    }
  }
};
</script>